import api from '@api'

const getters = {
  getUnitManagers: state => state.unitManagersList,
  getProjectManagers: state => state.projectManagersList,
  getAccountManagers: state => state.accountManagersList,
  getAllocations: state => state.allocations,
  getAvailability: state => state.availability,
  getEmploymentTypes: state => state.employmentTypes,
  getEnglishLevels: state => state.englishLevels,
  getPaymentTypes: state => state.paymentTypes,
  getSeniorityLevels: state => state.seniorityLevels,
  getLoadedUser: state => state.loadedUser
}

const actions = {
  setUnitManagers ({ commit }, data) {
    commit('setUnitManagers', data)
  },
  setProjectManagers ({ commit }, data) {
    commit('setProjectManagers', data)
  },
  setAccountManagers ({ commit }, data) {
    commit('setAccountManagers', data)
  },
  async fetchAllocations ({ commit, state }) {
    if (state.allocations.length) {
      return state.allocations
    } else {
      try {
        const { data } = await api.users.getAllocations()
        commit('setAllocations', data)
        return data
      } catch (error) {
        console.error('Ошибка при загрузке allocations:', error)
      }
    }
  },
  setAllocations ({ commit }, data) {
    commit('setAllocations', data)
  },
  async fetchAvailability ({ commit, state }) {
    if (state.availability.length) {
      return state.availability
    } else {
      try {
        const { data } = await api.users.getAvailability()
        commit('setAvailability', data)
        return data
      } catch (error) {
        console.error('availability:', error)
      }
    }
  },
  setAvailability ({ commit }, data) {
    commit('setAvailability', data)
  },
  async fetchEmploymentTypes ({ commit, state }) {
    if (state.employmentTypes.length) {
      return state.employmentTypes
    } else {
      try {
        const { data } = await api.users.getEmploymentTypes()
        commit('setEmploymentTypes', data)
        return data
      } catch (error) {
        console.error('employmentTypes:', error)
      }
    }
  },
  setEmploymentTypes ({ commit }, data) {
    commit('setEmploymentTypes', data)
  },
  async fetchEnglishLevels ({ commit, state }) {
    if (state.englishLevels.length) {
      return state.englishLevels
    } else {
      try {
        const { data } = await api.users.getEnglishLevels()
        commit('setEnglishLevels', data)
        return data
      } catch (error) {
        console.error('englishLevels:', error)
      }
    }
  },
  setEnglishLevels ({ commit }, data) {
    commit('setEnglishLevels', data)
  },
  async fetchPaymentTypes ({ commit, state }) {
    if (state.paymentTypes.length) {
      return state.paymentTypes
    } else {
      try {
        const { data } = await api.users.getPaymentTypes()
        commit('setPaymentTypes', data)
        return data
      } catch (error) {
        console.error('paymentTypes:', error)
      }
    }
  },
  setPaymentTypes ({ commit }, data) {
    commit('setPaymentTypes', data)
  },
  async fetchSeniorityLevels ({ commit, state }) {
    if (state.seniorityLevels.length) {
      return state.seniorityLevels
    } else {
      try {
        const { data } = await api.users.getSeniorityLevels()
        commit('setSeniorityLevels', data)
        return data
      } catch (error) {
        console.error('seniorityLevels:', error)
      }
    }
  },
  setSeniorityLevels ({ commit }, data) {
    commit('setSeniorityLevels', data)
  },
  setLoadedUser ({ commit }, data) {
    commit('setLoadedUser', data)
  }
}

const mutations = {
  setUnitManagers (state, data) {
    state.unitManagersList = data
  },
  setProjectManagers (state, data) {
    state.projectManagersList = data
  },
  setAccountManagers (state, data) {
    state.accountManagersList = data
  },
  setAllocations (state, data) {
    state.allocations = data
  },
  setAvailability (state, data) {
    state.availability = data
  },
  setEmploymentTypes (state, data) {
    state.employmentTypes = data
  },
  setEnglishLevels (state, data) {
    state.englishLevels = data
  },
  setPaymentTypes (state, data) {
    state.paymentTypes = data
  },
  setSeniorityLevels (state, data) {
    state.seniorityLevels = data
  },
  setLoadedUser (state, data) {
    state.loadedUser = data
  }
}

const state = {
  unitManagersList: [],
  projectManagersList: [],
  accountManagersList: [],
  allocations: [],
  availability: [],
  employmentTypes: [],
  englishLevels: [],
  paymentTypes: [],
  seniorityLevels: [],
  loadedUser: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
